export default {
    "groupName": "paper-towels-bounty-select-a-size-doubles-plus",
    "productType": "PaperTowels",
    "pricePerArticle": 208,
    "articleType": "Roll",
    "brandName": "Bounty ",
    "displayName": "Select a Size Doubles Plus ",
    "imageUrl": "https://images.ctfassets.net/qhwoiitgc21a/25bQxjrY2QJ094oH3s8CVI/db847ee5f6656b0ceba55c499bf048e7/bounty-2-5.png",
    "badges": [
        "NationallyRecognizedBrandLead"
    ],
    "description": "The Quicker Picker Upper and #1 bestselling paper towel in the US, Bounty Select a Size gives you the confidence to handle any size mess. \n\n",
    "possibleArticleCounts": [
        2,
        4,
        6,
        8,
        10,
        12
    ],
    "status": "Active",
    "available": true,
    "replaceWith": null,
    "isRefill": false,
    "displayUnits": null,
    "articlesPerDay": 0.05838709677419355,
    "articles": 2,
    "proposedArticles": 2,
    "cappedArticleCounts": [
        2,
        4,
        6,
        8,
        10
    ],
    // new fields
    // longDescription: "What is Lorem Ipsum? Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    // useInstructions: "Why do we use it? It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.",
    // ingredients: "Where does it come from? Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.",
    // highlights: [
    //     "Mrs. Meyer’s Clean Day Basil Liquid Hand Soap is made from bottle packaging that is recyclable and made from at least 30% post-consumer plastic.",
    //     "Mrs. Meyer’s Clean Day Basil Liquid Hand Soap is an effective and trusted formula that is made without Parabens & Phthalates, MEA & DEA and Artificial Colors. ",
    //     "Made using a cruelty-free formula, Mrs. Meyer’s Clean Day Basil Liquid Hand Soap is not tested on animals.",
    //     "Mrs. Meyer’s Clean Day is rooted in goodness and hardworking homekeeping."
    // ]
}